import { createReducer, on } from '@ngrx/store';

import * as JobBoardActions from './job-board.actions';
import { initialState } from './state';

export const jobBoardReducer = createReducer(
  initialState,
  on(JobBoardActions.loadJobBoards, JobBoardActions.getJobBoard, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(JobBoardActions.loadJobBoardsSuccess, (state, action) => ({
    ...state,
    list: action.jobBoards,
    isLoading: false,
  })),
  on(JobBoardActions.getActiveJobBoardsForJobSuccess, (state, action) => ({
    ...state,
    activeJobBoardsForJob: action.jobBoardsForJob,
  })),
  on(JobBoardActions.loadJobBoardsWithoutPaginationSuccess, (state, action) => ({
    ...state,
    allJobBoardsList: action.allJobBoards,
  })),
  on(JobBoardActions.getJobBoardSuccess, (state, { jobBoard }) => {
    const updateList = state.allJobBoardsList ? [...state.allJobBoardsList, jobBoard] : [jobBoard];
    return { ...state, allJobBoardsList: updateList, isLoading: false };
  }),
  on(JobBoardActions.getJobBoardSuccess, JobBoardActions.selectJobBoard, (state, { jobBoard }) => ({
    ...state,
    selectedJobBoard: jobBoard,
    isLoading: false,
  })),
  on(JobBoardActions.unselectJobBoard, (state) => ({ ...state, selectedJobBoard: null })),
  on(JobBoardActions.updateJobBoardSuccess, (state, { jobBoard }) => {
    let updatedList;
    if (state.list?.content) {
      const tempList = state.list;
      updatedList = {
        ...state,
        list: {
          ...tempList,
          content: state.list.content.map((sp) => (sp.id === jobBoard.id ? jobBoard : sp)),
        },
      };
    } else {
      updatedList = { ...state, content: [jobBoard] };
    }
    return { ...state, list: updatedList.list };
  }),
  on(JobBoardActions.updateJobBoardPostForJobSuccess, (state, { jobBoardPost }) => {
    if (
      state.activeJobBoardsForJob.find((activeJobBoard) => activeJobBoard.id === jobBoardPost.id)
    ) {
      const updatedList = state.activeJobBoardsForJob.map((sp) =>
        sp.id === jobBoardPost.id ? jobBoardPost : sp,
      );
      return { ...state, activeJobBoardsForJob: updatedList };
    } else {
      return { ...state, activeJobBoardsForJob: [...state.activeJobBoardsForJob, jobBoardPost] };
    }
  }),
  on(
    JobBoardActions.loadJobBoardsFailure,
    JobBoardActions.updateJobBoardFailure,
    JobBoardActions.getJobBoardFailure,
    (state, { error }) => ({ ...state, error, isLoading: false }),
  ),
  on(JobBoardActions.uploadLogoJobBoard, (state) => ({ ...state, logoAttachmentLoading: true })),
  on(JobBoardActions.uploadLogoJobBoardSuccess, (state, { attachment }) => ({
    ...state,
    logoAttachment: attachment,
    logoAttachmentLoading: false,
  })),
  on(JobBoardActions.uploadLogoJobBoardFailure, (state, { error }) => ({
    ...state,
    logoAttachment: null,
    error,
    logoAttachmentLoading: false,
  })),
  on(JobBoardActions.uploadHeaderJobBoard, (state) => ({
    ...state,
    headerAttachmentLoading: true,
  })),
  on(JobBoardActions.uploadHeaderJobBoardSuccess, (state, { attachment }) => ({
    ...state,
    headerAttachment: attachment,
    headerAttachmentLoading: false,
  })),
  on(JobBoardActions.uploadHeaderJobBoardFailure, (state, { error }) => ({
    ...state,
    headerAttachment: null,
    error,
    headerAttachmentLoading: false,
  })),
  on(JobBoardActions.loadNumberOfJobsForExtendedReferralSuccess, (state, { totalElements }) => ({
    ...state,
    totalElementsForExtendedReferral: totalElements,
  })),
);
